import { MenuList as MUIMenuList, type MenuListProps } from '@mui/material';

export { type MenuListProps } from '@mui/material';

export function MenuList(props: MenuListProps) {
  return <MUIMenuList {...props} />;
}
